<div class="mx-5 mb-5" id="myPdf" *ngIf="deliveryRequests">
  <div
    class="mx-5 my-5 print-wrap page{{ j + 1 }}"
    id="page{{ j }}"
    *ngFor="let item of slices; let j = index"
  >
    <div class="row mx-5">
      <div class="col-6 text-left mt-5">
        <img
          class="img-fluid"
          style="width: 60%"
          src="../../../assets/img/modal/intigrow.png"
        />
        <h4>INTIGROW SA</h4>
        <p>24 rue Ibn hazem Andalousie,</p>
        <p>Menzah 6 Ariana</p>
        <p>Tél : 56 83 76 52</p>
        <p>info@intigo.tn</p>
        <p>www.intigo.tn</p>
        <br />
        <br />
      </div>
      <div class="col-6 text-center mt-5">
        <h3>Etat de journal :</h3>
        <br />
        <br />
        <br />
        <div class="text-center">
          <h5>Date: {{ today | date: "dd/MM/yyyy hh:mm" }}</h5>
          <h5>Nombre de colis: {{ slices[j].requests.length }}</h5>
          <h5>Montant à collecter: {{ pdfTotal }} DT</h5>
        </div>
        <br />
      </div>
    </div>
    <div class="row mx-5 pb-5">
      <br />
      <br />
      <br />
      <table class="table table-striped">
        <thead class="items-header-section table-header">
          <tr>
            <th scope="col">Numéro</th>
            <th scope="col">Client</th>
            <th scope="col" *ngIf="jobsType === 'dropOff'">Client final</th>
            <th scope="col" *ngIf="jobsType === 'dropOff'">
              N. de téléphone de client final
            </th>
            <th scope="col" *ngIf="jobsType === 'pickUp'">
              N. de téléphone de client
            </th>
            <th scope="col" *ngIf="jobsType === 'dropOff'">
              Adresse de client final
            </th>
            <th scope="col" *ngIf="jobsType === 'pickUp'">Adresse de client</th>
            <!-- <th scope="col">Chauffeur a retourné l'argent </th> -->
            <th scope="col">Client a reçu son argent</th>
            <th scope="col">Cash</th>
            <th scope="col">Check</th>
            <th scope="col">Prix</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let req of slices[j].requests; let i = index">
            <th scope="row">{{ req?.nid }}</th>
            <td *ngIf="jobsType === 'dropOff'">
              {{ req?.business?.nomCommercial }}
            </td>
            <td *ngIf="jobsType === 'pickUp'">
              {{ req?.business?.nomCommercial }}
            </td>
            <td *ngIf="jobsType === 'dropOff'">
              {{ req?.deliveredToName }}
            </td>
            <td *ngIf="jobsType === 'pickUp'">{{ req?.business?.tel }}</td>
            <td *ngIf="jobsType === 'dropOff'">
              {{ req?.deliveredToPhone }}
            </td>
            <td *ngIf="jobsType === 'pickUp'">
              {{ req?.pickUp?.pickUpAddress }}
            </td>
            <td *ngIf="jobsType === 'dropOff'" class="ft-10">
              {{ req?.dropOffAddress }}
            </td>
            <!-- <td>{{req.moneyReceivedFromDriver ? 'Oui' :'Non' }}</td> -->
            <td>{{ req.moneySentToClient ? "Oui " : "Non" }}</td>
            <td>{{ req?.collectedInCash }}</td>
            <td>{{ req?.collectedInCheck }}</td>

            <td>{{ req?.amount }}DT</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<iframe
  class="d-none"
  frameBorder="0"
  id="sample-pdf"
  style="right: 0; top: 53px; bottom: 0; height: 400px; width: 100%"
>
</iframe>

<a id="pdf-download-link" title="Download PDF File">Download PDF file</a>
